<div class="training-content" [class.cancel-mark]="isCancelTraining" [class.attention-line]="attention_flg">
  <caremoni-dynamic-label *ngIf="trainingType > 0"
    [data]="trainingText"
    [config]="labelConfig"
  >
  </caremoni-dynamic-label>
</div>
